import { render, staticRenderFns } from "./QuestionnaireInfo.vue?vue&type=template&id=54264b7a&scoped=true"
import script from "./QuestionnaireInfo.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireInfo.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireInfo.vue?vue&type=style&index=0&id=54264b7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54264b7a",
  null
  
)

export default component.exports